import { ReactNode } from 'react';

interface SectionHeaderProps {
  title?: string | ReactNode;
  subtitle?: string | ReactNode;
  titleClassName?: string;
  subtitleClassName?: string;
  alignment?: 'left' | 'center' | 'right';
  className?: string;
  badge?: string;
  badgeColor?: string;
}

const alignmentClasses = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

export function SectionHeader({
  title,
  subtitle,
  titleClassName = 'text-3xl md:text-4xl font-bold text-gray-900',
  subtitleClassName = 'text-lg text-gray-600',
  alignment = 'center',
  className = '',
  badge,
  badgeColor = 'bg-primary-100 text-primary-700',
}: SectionHeaderProps) {
  if (!title && !subtitle && !badge) return null;

  return (
    <div className={`${alignmentClasses[alignment]} ${className}`}>
      {badge && (
        <span className={`inline-block px-4 py-1 ${badgeColor} rounded-full text-sm font-medium mb-4`}>
          {badge}
        </span>
      )}
      {title && (
        <h2 className={`${titleClassName} ${subtitle ? 'mb-4' : ''}`}>
          {title}
        </h2>
      )}
      {subtitle && (
        <p className={subtitleClassName}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
